/* global axios */
import ApiClient from './ApiClient';

class PendingAlertsAPI extends ApiClient {
  constructor() {
    super('pending_alerts', { accountScoped: true });
  }

  getPendingAlerts() {
    return axios.get(this.url);
  }

  suppressAlert(conversationId, alertRuleId) {
    return axios.post(`${this.apiVersion}/accounts/${this.accountIdFromRoute}/conversations/${conversationId}/suppress_alert`, {
      alert_rule_id: alertRuleId,
    });
  }
}

export default new PendingAlertsAPI();
